import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Typography } from '@totalsoft/rocket-ui';
import { Box } from '@mui/material';
import { ThemedWrapper } from 'components/common/SurfaceStyles';

const CardNoResultsWrapper = ({ content, message, children, ...rest }) => {
  const { t } = useTranslation();
  const isContentEmpty = useMemo(() => content && content.length === 0, [content]);

  return (
    <Box mt={2} {...rest}>
      {!isContentEmpty && children}
      {isContentEmpty && (
        <ThemedWrapper>
          <Typography>{message ?? t('ResultsNotFound')}</Typography>
        </ThemedWrapper>
      )}
    </Box>
  );
};

CardNoResultsWrapper.propTypes = {
  content: PropTypes.array.isRequired,
  message: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.array.isRequired, PropTypes.object.isRequired])
};

export default CardNoResultsWrapper;
